<template>
    <div class="carousel">
        <slot></slot>
    </div>    
</template>
